import React from "react";
import styled from "styled-components";

const StyledGoBackLink = styled.a`
  color: var(--sumi-darker-blue);
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 2rem;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  text-align: left;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background-color: #f8fafc;
  transition: all 0.2s ease;

  &:hover {
    color: var(--sumi-dark-blue);
    background-color: #f1f5f9;
    border-color: #cbd5e1;
    transform: translateX(-2px);
  }

  &:before {
    content: "←";
    font-size: 18px;
    font-weight: bold;
    margin-right: 4px;
  }
`;

interface GoBackLinkProps {
  onClick: () => void;
  children: React.ReactNode;
}

const GoBackLink: React.FC<GoBackLinkProps> = ({ onClick, children }) => {
  return <StyledGoBackLink onClick={onClick}>{children}</StyledGoBackLink>;
};

export default GoBackLink;
